import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Popover from "@mui/material/Popover";
import { useNavigate } from "react-router";
import { ROUTE_NAME } from "../../router/types/CommonTypes";
import useAuthValue from "../../modules/authModule/hooks/useAuthValue";
import useLogoutMutation from "../../modules/authModule/hooks/useLogoutMutation";
import Divider from "../Divider";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import getInitials from "../../helpers/getInitials";
import { MenuItem } from "@mui/material";

const UserMenu = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { firstName, LastName, user, realm } = useAuthValue();
  const isSuperUser = user?.isSuperUser;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { mutate: logoutMutate } = useLogoutMutation();

  const portalRoot = document.getElementById("portal-root");

  if (!portalRoot) {
    console.error("Portal root not found");
    return null;
  }

  const handleMenuPress = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const initials = getInitials(firstName, LastName);

  return (
    <>
      <Avatar
        onClick={handleMenuPress}
        sx={{
          height: 40,
          width: 40,
          bgcolor: "#FFFFFF",
          color: "#5921F2",
          ml: 1,
          fontSize: 16,
          fontWeight: "700",
        }}
      >
        {initials}
      </Avatar>
      <Popover
        sx={{ mt: 1.5 }}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Stack
          width={341}
          borderRadius={12}
          gap={2}
          p={2}
          boxSizing="border-box"
          border="0px 4px 12px rgba(0, 0, 0, 0.1)"
        >
          <Stack alignItems="center" sx={{ textAlign: "center" }}>
            <Typography variant="body2" color="textSecondary">
              {realm}
            </Typography>
            <Avatar
              sx={{
                height: 80,
                width: 80,
                bgcolor: "#5921F2",
                color: "#FFFFFF",
                fontSize: 32,
                fontWeight: "700",
                my: 2,
              }}
            >
              {initials}
            </Avatar>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              {firstName} {LastName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {user?.username}
            </Typography>
            <Divider sx={{ marginTop: "20px" }} />
          </Stack>

          <Stack>
            <Typography fontSize={14} fontWeight={700} color="#595959">
              {t("User_Control_Menu")}
            </Typography>
            {!isSuperUser && (
              <MenuItem
                onClick={() => {
                  navigate("/" + ROUTE_NAME.USER_ACCOUNT);
                  setAnchorEl(null);
                }}
                sx={{
                  fontSize: 18,
                }}
              >
                {t("Account_Settings")}
              </MenuItem>
            )}
            <MenuItem
              onClick={() => logoutMutate()}
              sx={{
                fontSize: 18,
                mt: 2,
              }}
            >
              {t("Log_Out")}
            </MenuItem>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};

export default UserMenu;
